export const validationServices = { validatePhoneNumber, validateText };

function validatePhoneNumber(input_str) {
    var re = /^\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})$/;
    return re.test(input_str);
}
function validateText(input_str) {
    //var regex = /^[a-zA-Z\s]+$/;
    var regex = /^[a-zA-Z0-9\s\-\_\.\&\%\#\@]+$/;
    return regex.test(input_str);
}